export enum ProcessorResponse {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  NO_ATTEMPT = 'NO_ATTEMPT',
  WANTS_3DS_CHALLENGE = '3DS_CHALLENGE',
  SIGNUP_LIMIT = 'SIGNUP_LIMIT',
}
